import React, { useContext, useState } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Grid,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { TipoUfficioContext } from '../TipoUfficioContext';

import { DateTableRow, FileDialog, UtenteTableRow } from '../../../common';

import DeleteIcon from "@mui/icons-material/Delete";

import { Field, Formik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

const TipoSchema = Yup.object().shape({
    nome: Yup.string().required("Il nome è un campo obbligatorio"),
    ordine: Yup.number().nullable().notRequired(),
});

export const TipoDetails = ({
    disabled,
    formRef,
    onActionClick,
    ...props
}) => {

    const {
        state,
        setState,

        isAddingFile,
        addFileAsync,
    } = useContext(TipoUfficioContext);

    const {
        tipo,
        iconFiles,
    } = state;

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            if (onActionClick)
                onActionClick("Submit", values);
    }

    const [openIconDialog, setOpenIconDialog] = useState(false);

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={
                    {
                        nome: tipo?.nome ?? "",
                        ordine: tipo?.ordine ?? null,
                        filtroRicerca: tipo?.filtroRicerca ?? false,
                        filtroRicercaDistrettuale: tipo?.filtroRicercaDistrettuale ?? false,
                        filtroRicercaTipoUfficio: tipo?.filtroRicercaTipoUfficio ?? false,
                        altroUfficio: tipo?.altroUfficio ?? false,
                        inizioValidita: tipo?.inizioValidita ?? moment.utc([1946, 5, 2]),
                        fineValidita: tipo?.fineValidita ?? null,
                        padreId: tipo?.padreId,
                        competenzaId: tipo?.competenzaId ?? null,
                        urlIcona: tipo?.urlIcona,
                    }
                }
                enableReinitialize
                validationSchema={TipoSchema}
                onSubmit={handleOnSubmit}
            >
                {({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                }) => {
                    return <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid item xs={12}>
                                <Card>
                                    <CardHeader
                                        sx={{
                                            color: "white",
                                            backgroundColor: "secondary.main",
                                        }}
                                        title={
                                            <Grid container alignItems="center" justify="space-between">
                                                <Grid item>
                                                    <Typography variant="h6">Informazioni</Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                    <Divider />
                                    <CardContent sx={{ padding: "0px !important" }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Nome
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="nome"
                                                            name="nome"
                                                            value={values.nome}
                                                            onChange={handleChange}
                                                            error={touched.nome && Boolean(errors.nome)}
                                                            helperText={touched.nome && errors.nome}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Ordine
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="ordine"
                                                            name="ordine"
                                                            type="number"
                                                            value={values.ordine}
                                                            onChange={handleChange}
                                                            error={touched.ordine && Boolean(errors.ordine)}
                                                            helperText={touched.ordine && errors.ordine}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Filtro ricerca
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="filtroRicerca"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('filtroRicerca', e.target.checked);
                                                            }}
                                                            checked={values.filtroRicerca}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Filtro ricerca distrettuale
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="filtroRicercaDistrettuale"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('filtroRicercaDistrettuale', e.target.checked);
                                                            }}
                                                            checked={values.filtroRicercaDistrettuale}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Mostra su ricerca tipo ufficio
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="filtroRicercaTipoUfficio"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('filtroRicercaTipoUfficio', e.target.checked);
                                                            }}
                                                            checked={values.filtroRicercaTipoUfficio}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Altro ufficio
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="altroUfficio"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('altroUfficio', e.target.checked);
                                                            }}
                                                            checked={values.altroUfficio}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Icona
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button
                                                            onClick={() => setOpenIconDialog(true)}>
                                                            {
                                                                values.urlIcona ?
                                                                    <img
                                                                        height="60px"
                                                                        src={`${values.urlIcona}`}
                                                                        loading="lazy" />
                                                                    :
                                                                    "Scegli un'immagine"
                                                            }
                                                        </Button>
                                                        {
                                                            values.urlIcona &&
                                                            <IconButton
                                                                aria-label="delete"
                                                                disabled={disabled}
                                                                onClick={() => setFieldValue('urlIcona', null)}
                                                            >
                                                                <Tooltip title="rimuovi icona">
                                                                    <DeleteIcon />
                                                                </Tooltip>
                                                            </IconButton>
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Inizio validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="inizioValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                setFieldValue('inizioValidita', value ? moment.utc([value.year(), value.month(), value.date()]) : null);

                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.inizioValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Fine validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="fineValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                setFieldValue('fineValidita', value ? moment.utc([value.year(), value.month(), value.date()]) : null);

                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.fineValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <UtenteTableRow label={'Creato da'} utenteId={tipo?.creatoDa} />
                                                <DateTableRow label={'Data creazione'} stringDate={tipo?.dataCreazione} />
                                                <UtenteTableRow label={'Ultima modifica da'} utenteId={tipo?.aggiornatoDa} />
                                                <DateTableRow label={'Data ultima modifica'} stringDate={tipo?.dataAggiornamento} />
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                        <FileDialog
                            title=""
                            open={openIconDialog}
                            handleClose={() => setOpenIconDialog(false)}
                            handleSubmit={imageUrl => {
                                setFieldValue("urlIcona", imageUrl);
                                setOpenIconDialog(false);
                            }}
                            handleOnFileDrop={addFileAsync}
                            imageUrls={iconFiles} />
                    </form>
                }}
            </Formik>
        </>
    );
}